import { render, staticRenderFns } from "./BindDangao.vue?vue&type=template&id=264f7684&scoped=true"
import script from "./BindDangao.vue?vue&type=script&lang=js"
export * from "./BindDangao.vue?vue&type=script&lang=js"
import style0 from "./BindDangao.vue?vue&type=style&index=0&id=264f7684&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f7684",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264f7684')) {
      api.createRecord('264f7684', component.options)
    } else {
      api.reload('264f7684', component.options)
    }
    module.hot.accept("./BindDangao.vue?vue&type=template&id=264f7684&scoped=true", function () {
      api.rerender('264f7684', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/brandlist/BindDangao.vue"
export default component.exports